module.exports = __webpack_public_path__ + "img/idcard_teamcard.6005d587.svg";